/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_error_return_to_home17 = /** @type {(inputs: {}) => string} */ () => {
	return `Return to Home`
};

const fr_error_return_to_home17 = /** @type {(inputs: {}) => string} */ () => {
	return `Retourner à l'accueil`
};

const de_error_return_to_home17 = /** @type {(inputs: {}) => string} */ () => {
	return `Zur Hauptseite zurückkehren`
};

const es_error_return_to_home17 = /** @type {(inputs: {}) => string} */ () => {
	return `Vuelve al inicio`
};

const it_error_return_to_home17 = /** @type {(inputs: {}) => string} */ () => {
	return `Tornare a casa`
};

const ar_error_return_to_home17 = /** @type {(inputs: {}) => string} */ () => {
	return `العودة إلى الصفحة الرئيسية`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const error_return_to_home17 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.error_return_to_home17(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("error_return_to_home17", locale)
	if (locale === "en") return en_error_return_to_home17(inputs)
	if (locale === "fr") return fr_error_return_to_home17(inputs)
	if (locale === "de") return de_error_return_to_home17(inputs)
	if (locale === "es") return es_error_return_to_home17(inputs)
	if (locale === "it") return it_error_return_to_home17(inputs)
	return ar_error_return_to_home17(inputs)
};
export { error_return_to_home17 as "ERROR_RETURN_TO_HOME" }